<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="110px" :model="form">
      <el-form-item label="企业">
        <el-tag v-if="form.corp_id!=''" style="margin-right:10px">{{ form.corp_name }} ({{ form.corp_id }}) </el-tag>
        <el-button type="warning" size="mini" @click="choose('企业')">选择企业</el-button>
      </el-form-item>
      <!-- <el-form-item label="企业员工">
        <el-tag v-for="items,index in form.corp_user" :key="index" style="margin-right:10px" closable @close="handleClose(items.user_id,index)">{{ items.name }} </el-tag>
        <el-button v-if="type === 1" :disabled="form.corp_id===''" type="warning" size="mini" @click="chorwe">选择企业员工</el-button>
        <el-button v-if="type === 2" :disabled="form.corp_id===''" type="primary" size="mini" @click="choose('企业员工')"  >编辑企业员工</el-button>
      </el-form-item> -->
      <!-- <el-form-item label="公众号">
        <el-tag v-for="items,index in form.official_account" :key="index" style="margin-right:10px" closable @close="handleCloseacc(items.app_id,index)">{{ items.account_name }} </el-tag>
        <el-button type="warning" size="mini" @click="chorwer">选择公众号</el-button>
      </el-form-item> -->
      <el-form-item label="广告主">
        <el-tag v-if="form.account_id!=''" style="margin-right:10px">{{ form.advertiser_name }} </el-tag>
        <el-button type="warning" size="mini" @click="adchange">选择广告主</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" size="mini" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="dialogType"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60%"
    >
      <enterprise v-if="dialogType === '请选择企业'" @callback="callback" />
      <official-choose v-if="dialogType === '请选择公众号'" @official="official" />
      <sp-work-choose v-if="dialogType === '请选择企业员工'" ref="workchoose" @spWork="spWork" />
    </el-dialog>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>
    <el-dialog
      title="选择公众号"
      :visible.sync="dialogVisibleacc"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandaccount ref="bandaccountview" @bandarrview="bandarrview" />
    </el-dialog>
    <el-dialog
      title="选择广告主"
      :visible.sync="dialogVisiblead"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <adband ref="adbandview" @official="official" />
    </el-dialog>
  </div>
</template>

<script>
import bandstaff from '../../behavioralsource/components/bandstaff.vue'
import enterprise from '../../behavioralsource/components/enterprise.vue'
import officialChoose from '../../behavioralsource/components/officialChoose.vue'
import spWorkChoose from '../../behavioralsource/components/spWorkChoose.vue'
import bandaccount from './bandaccount.vue'
import adband from './adband.vue'
import { customAudiencesbinding } from '@/api/ad.js'
export default {
  components: { bandstaff, enterprise, officialChoose, spWorkChoose, bandaccount, adband },
  data() {
    return {
      form: {
        corp_id: '',
        corp_name: '',
        // corp_user: [],
        // official_account: [],
        account_id: '',
        advertiser_name: ''
      },
      type: null,
      dialogType: null,
      dialogVisible: false,
      dialogVisibler: false,
      dialogVisibleacc: false,
      dialogVisiblead: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    opens(type, id) {
      if (type === 1) {
        this.type = type
        console.log(type)
      } else {
        console.log(type)
        this.type = type
        // this.ids = id
        // this.info()
      }
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.form.corp_id)
      })
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      this.dialogVisibler = false
      this.form.corp_user = arr
      console.log(arr, 'arr---')
    },
    choose(type) {
      this.dialogType = `请选择${type}`
      this.dialogVisible = true
      if (type === '企业员工') {
        console.log('111')
        this.$nextTick(() => {
          this.$refs.workchoose.open(this.form.corp_id)
        })
      }
    },
    spWork(item) {
      console.log(item)
      this.dialogVisible = false
      this.form.corp_user[0].name = item.name
      this.form.corp_user[0].user_id = item.user_id
    },
    // 选择企业回调
    callback(item) {
      this.dialogVisible = false
      this.form.corp_name = item.corp_name
      this.form.corp_id = item.corp_id
    },
    handleClose(id, index) {
      console.log(index)
      this.form.corp_user.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bandstaffview.set(id)
      }, 100)
    },
    handleCloseacc(id, index) {
      console.log(index)
      this.form.official_account.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bandaccountview.set(id)
      }, 100)
    },
    chorwer() {
      this.dialogVisibleacc = true
      this.$nextTick(() => {
        this.$refs.bandaccountview.sendr()
      })
    },
    bandarrview(arr) {
      this.dialogVisibleacc = false
      this.form.official_account = arr
      console.log(arr)
    },
    adchange() {
      this.dialogVisiblead = true
      // this.$nextTick(() => {
      //   this.$refs.adbandview.sendr()
      // })
    },
    official(item) {
      this.dialogVisiblead = false
      this.form.account_id = item.account_id
      this.form.advertiser_name = item.account_name
    },
    async sumbit() {
      if (this.form.corp_id === '') {
        this.$message.error('请选择企业')
        return
      }
      // if (this.form.corp_user.length === 0) {
      //   this.$message.error('请选择企业人员')
      //   return
      // }
      // if (this.form.official_account.length === 0) {
      //   this.$message.error('请选择公众号')
      //   return
      // }
      if (this.form.account_id === '') {
        this.$message.error('请选择广告主')
        return
      }
      console.log(this.form)
      const data = await customAudiencesbinding(this.form)
      console.log(data)
      this.$emit('updata')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
